export const AUTH_COOKIE = "AUTH_COOKIE";
export const DAYS_IN_MILLISECONDS = 1000 * 60 * 60 * 24
export const PLATFORM = "platform"
export const CONVEYOR = "conveyor"
